import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import {
  loading,
  fetchEncodings,
  createEncoding,
  deleteEncoding,
  selectEncoding,
  encode,
  addTone,
  updateTone,
  deleteTone,
  fetchExperiences,
  clearCms,
} from './actions';

export const initialState = {
  loading: false,
  status: 'none',
  campaigns: [], // all campaigns
  encodings: [], // library
  selectedId: null,
  experiences: [],
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state =>
        update(state, {
          loading: { $set: true },
        }),
    },

    [fetchEncodings]: {
      next: (state, { payload }) => {
        payload.forEach(encodingsItem => {
          encodingsItem.tones.forEach(toneItem => {
            if (
              toneItem.hasOwnProperty('experience') &&
              typeof toneItem.experience === 'string'
            ) {
              const index = state.experiences
                .map(el => el._id)
                .indexOf(toneItem.experience);
              if (index >= 0) {
                toneItem.experience = state.experiences[index];
              }
            }
          });
        });
        const newState = update(state, {
          loading: { $set: false },
          encodings: { $set: payload || [] },
          selectedId: {
            $set: payload.length ? payload[0]._id : null,
          },
        });
        // console.log('depois state', newState);
        return newState;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          encodings: { $set: [] },
          selectedId: { $set: null },
        });
      },
    },

    [createEncoding]: {
      next: (state, { payload }) => {
        // console.log('createEncoding', payload);
        return update(state, {
          loading: { $set: false },
          encodings: { $push: [payload] },
          selectedId: { $set: payload._id },
        });
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [deleteEncoding]: {
      next: (state, { payload }) => {
        // console.log('deleteEncoding', payload);
        const index = state.encodings.map(el => el._id).indexOf(payload._id);
        if (index >= 0) {
          // Delete
          state = update(state, {
            encodings: { $splice: [[index, 1]] },
          });
          // Update selected
          return update(state, {
            loading: { $set: false },
            selectedId: {
              $set: state.encodings.length ? state.encodings[0]._id : null,
            },
          });
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [selectEncoding]: {
      next: (state, { payload }) => {
        // console.log('selectEncoding', payload);
        return update(state, {
          selectedId: { $set: payload._id },
        });
      },
    },

    [encode]: {
      next: (state, { payload }) => {
        let result = state;
        const index = state.encodings.map(el => el._id).indexOf(payload._id);

        if (index >= 0) {
          result = update(state, {
            loading: { $set: false },
            encodings: { [index]: { status: { $set: 'processing' } } },
          });
        }
        return result;
      },
    },

    [addTone]: {
      next: (state, { payload }) => {
        const index = state.encodings
          .map(el => el._id)
          .indexOf(payload.encoding);
        if (index >= 0) {
          return update(state, {
            loading: { $set: false },
            encodings: { [index]: { tones: { $push: [payload] } } },
          });
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [updateTone]: {
      next: (state, { payload }) => {
        let result = state;
        let encodings = state.encodings;
        let findToneIndex = -1;
        let findEncoIndex = -1;
        if (typeof encodings !== 'undefined' && encodings.length > 0) {
          for (let encoIndex = 0; encoIndex < encodings.length; encoIndex++) {
            let tones = encodings[encoIndex].tones;
            if (typeof tones !== 'undefined' && tones.length > 0) {
              for (let toneIndex = 0; toneIndex < tones.length; toneIndex++) {
                if (tones[toneIndex]._id === payload._id) {
                  findToneIndex = toneIndex;
                  findEncoIndex = encoIndex;
                  break;
                }
              }
            }
          }
        }
        if (findToneIndex >= 0) {
          result = update(state, {
            loading: { $set: false },
            encodings: {
              [findEncoIndex]: {
                tones: { [findToneIndex]: { $set: payload } },
              },
            },
          });
        }

        return result;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [deleteTone]: {
      next: (state, { payload }) => {
        const index = state.encodings.map(el => el._id).indexOf(payload._id);
        if (index >= 0) {
          return update(state, {
            loading: { $set: false },
            encodings: { [index]: { $set: payload } },
          });
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
        });
      },
    },

    [fetchExperiences]: {
      next: (state, { payload }) => {
        return update(state, {
          loading: { $set: false },
          experiences: { $set: payload.docs || [] },
        });
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          experiences: { $set: [] },
        });
      },
    },

    [clearCms]: {
      next: state => {
        return update(state, {
          loading: { $set: false },
          encodings: { $set: [] },
          selectedId: { $set: null },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
